module.exports = __webpack_public_path__ + "static/media/pending.9b298e3a.svg";